var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.875 7.5L5.875 8.22222L5.875 14",
    stroke: "#0B1836",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 7.5L9.125 8.22222L9.125 14",
    stroke: "#0B1836",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1875 5.0625L12.375 15.7266C12.375 16.1306 12.2038 16.5181 11.899 16.8038C11.5943 17.0895 11.181 17.25 10.75 17.25H4.25C3.81902 17.25 3.4057 17.0895 3.10095 16.8038C2.7962 16.5181 2.625 16.1306 2.625 15.7266L1.8125 5.0625H13.1875Z",
    stroke: "#0B1836",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0625 2V2.4375C5.0625 2.98978 5.51022 3.4375 6.0625 3.4375H8.9375C9.48978 3.4375 9.9375 2.98978 9.9375 2.4375V2C9.9375 1.44772 9.48978 1 8.9375 1H6.0625C5.51022 1 5.0625 1.44772 5.0625 2Z",
    stroke: "#0B1836"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.9375V4.5625C1 4.83864 1.22386 5.0625 1.5 5.0625H13.5C13.7761 5.0625 14 4.83864 14 4.5625V3.9375C14 3.66136 13.7761 3.4375 13.5 3.4375H1.5C1.22386 3.4375 1 3.66136 1 3.9375Z",
    stroke: "#0B1836"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/bin.ede37f8682094eac64d0f462aac55142.svg";
export { ForwardRef as ReactComponent };